import { GpsLocationHistory } from "../entities/GpsLocationHistory";
import { BaseService } from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class GpsLocationHistoryService extends BaseService<GpsLocationHistory>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, GpsLocationHistory);
    }
    protected getBaseUrl():string{
        return "gpslocationhistory";
    }
    protected getBasesUrl():string{
        return "gpslocationhistories";
    }
    getByAsset(assetId:number):ng.IPromise<GpsLocationHistory[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"asset/"+assetId, config);
    }
    getCountByAsset(assetId:number):ng.IPromise<number>{
        var config:any = {};
        return this.useGetHandler(this.getBasesUrl(),"assetcount/"+assetId, config);
    }
    getReport(groupByAsset: boolean, name: string, location: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string) {
        var config: any = {
            headers: {
                'Content-type': 'application/json',
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'arraybuffer'
        };
        var timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.useGetHandler("Report", "GpsLocationHistory?timeZoneId=" + timeZoneId + "&groupByAsset=" + groupByAsset + "&name=" + name + "&location=" + location + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getReportCount(groupByAsset: boolean, name: string, location: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string) {
        var config: any = {};
        return this.useGetHandler(this.getBasesUrl(), "ReportCount?groupByAsset=" + groupByAsset + "&name=" + name + "&location=" + location + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
    getReportItems(groupByAsset: boolean, name: string, location: string, assetType: string, department: string, disposalStatus: string, checkinStatus: string, missing: string): ng.IPromise<GpsLocationHistory[]> {
        var config: any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(), "Report?groupByAsset=" + groupByAsset + "&name=" + name + "&location=" + location + "&assetType=" + assetType + "&department=" + department + "&disposalStatus="
            + disposalStatus + "&checkinStatus=" + checkinStatus + "&missing=" + missing, config);
    }
}
